import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getSignupFormQuestions = async (
  token: string,
  baseUrl: string,
  config?: any
) => {
  try {
    const queryPath = `${baseUrl}/signup_form_questions`;

    const res = await get(token, queryPath, {}, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
